import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const state = {
  	user: null,
  	userCollection: [],
  	itemCollection: [],
    newRecipes: [],
    history: [],
    tableOptions: [
      {
        tableName: 'userCollection', 
        sort: {prop: 'displayName', order: 'ascending'},
        // filter: {colProp: 'displayName', value: ['minecraft-1.7.10']},
        filter: {colProp: 'displayName', value: []},
        search: null,
        page: 1,
        pageSize: 20,
      },
      {
        tableName: 'itemBase',
        sort: {prop: 'displayName', order: 'ascending'}, 
        // filter: {colProp: 'displayName', value: ['minecraft-1.7.10']},
        filter: {colProp: 'displayName', value: []},
        search: null,
        page: 1,
        pageSize: 20,
      },
    ],
    userOptions: {},
    filters: [],
    passiveMods: [],
};
const mutations = {
  	updateUser (state, { user }) {
    	Vue.set(state, 'user', user);
  	},
  	updateUserCollection (state, { userCollection }) {
    	Vue.set(state, 'userCollection', userCollection);
  	},
  	updateItemCollection (state, { itemCollection }) {
    	Vue.set(state, 'itemCollection', itemCollection);
  	},
    updateNewRecipes (state, { newRecipes }) {
      Vue.set(state, 'newRecipes', newRecipes);
    },
    updateHistory (state, { history }) {
      Vue.set(state, 'history', history);
    },
    updateTableOptions (state, { tableOptions }) {
      Vue.set(state, 'tableOptions', tableOptions);
    },
    updateUserOptions (state, { userOptions }) {
      Vue.set(state, 'userOptions', userOptions);
    },
    updateFilters (state, { filters }) {
      Vue.set(state, 'filters', filters);
    },
    updatePassiveMods (state, { passiveMods }) {
      Vue.set(state, 'passiveMods', passiveMods);
    },
};
const getters = {
  	user: state => state.user,
  	userCollection: state => state.userCollection,
  	itemCollection: state => state.itemCollection,
    newRecipes: state => state.newRecipes,
    history: state => state.history,
    tableOptions: state => state.tableOptions,
    hiddenMods: state => state.userOptions,
    filters: state => state.filters,
    passiveMods: state => state.passiveMods,
};
const actions = {
};
const store = new Vuex.Store({
  	state,
  	mutations,
  	actions,
  	getters,
});
export default store;